import { scopedTranslation } from '@utils/I18n'

import { ArchiveShiftsDocument } from '@frontend/graphql/mutations/archiveShifts.generated'

import { useRosterActionMutation } from '../roster_board/useRosterActionMutation'

const t = scopedTranslation('author_shifts')

type ArchiveShiftsArgs = {
  ids: string[]
  onSuccess: () => void
  onError?: () => void
}

export const useArchiveShiftsMutation = () => {
  const { run, isPending } = useRosterActionMutation({
    document: ArchiveShiftsDocument,
    succeeded: (response) => Boolean(response?.archiveShifts?.success),
    errorCode: 'ARCHIVE_SHIFT_ERROR',
    failureMessage: t('errors.delete_failed'),
    extractErrors: (response) => response?.archiveShifts?.errors,
  })

  return {
    archiveShifts: ({ ids, onSuccess, onError }: ArchiveShiftsArgs) => run({ ids, onSuccess, onError }),
    isPending,
  }
}
